import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeactivateModalService {
  private _deactivateModalOpen = new Subject<void>();
  public deactivateModalOpen$ = this._deactivateModalOpen.asObservable();

  public openModal(): void {
    this._deactivateModalOpen.next();
  }
}
